import 'bootstrap';
import ThirdParty from './modules/third-party'; // if default without curly braces
import Slick from './modules/slick-module';
import HeaderMenu from './modules/header-js';
import AjaxCpt from './modules/ajax-cpt';
import ClearBitIntegration from './modules/clearbit-integration';
import { Scroll, AddCSSClass, Site } from './modules/site-js';

HeaderMenu.onReady();
HeaderMenu.onHover();
HeaderMenu.onClickEvent();
HeaderMenu.onResize();
// ThirdParty.onLeadSquareSubmit();
// ThirdParty.onGatedFormSubmit();
ThirdParty.onInit();
Site.onClick();
Site.onReady();
Slick.onInit();
Scroll.onInit();
AddCSSClass.onInit();
AjaxCpt.onInit();
ClearBitIntegration.onInit();
